export default __webpack_public_path__ + "static/media/16.738bd409.png";